import {
  blue,
  green,
  lightBlue,
  lime,
  orange,
  pink,
  purple,
  red,
  teal,
  yellow,
} from "@mui/material/colors";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMap, useMapEvents } from "react-leaflet";
import { setCenter } from "../store/actions/mapSlice";
import ReactDOMServer from "react-dom/server";
import OrderMarker from "../components/map/markers/OrderMarker";
import L from "leaflet";

export const returnMarkerObject = (order) => {
  return {
    id: order.order_id,
    coord: [order.LAT, order.LONG],
    order_id: order.order_id,
    channel_order_id: order.channel_order_id,
    delivery_expected_time: order.delivery_expected_time,
    channel: order.channel,
    order_index: order.order_index,
    order_status: order.status,
    status_number: order.status_number,
    address: `${order.street}, ${order.number}, ${order.neighborhood}`,
    address_complement: order.address_complement,
    address_reference: order.address_reference,
    customer_name: order.customer_name,
    selectedToDispatch: order.selectedToDispatch,
    neighborhood_groups: order.neighborhood_groups,
  };
};

export const radiusColors = [
  blue[300],
  red[300],
  green[300],
  yellow[300],
  orange[300],
  purple[300],
  lightBlue[300],
  pink[300],
  teal[300],
  lime[300],
];

export const getOrderStatus = (statusNumber) => {
  if (statusNumber === 2) return "preparing";
  else return "packed";
};

export const updateMarkersArray = (array, coordinates, channelCode) => {
  if (!array) return;
  if (!array.find((marker) => marker.order_id === channelCode)) {
    array.push(coordinates);
  }
};

export const SetDragPosition = React.memo(() => {
  const dispatch = useDispatch();
  useMapEvents({
    dragend: (e) => {
      const center = e.target.getCenter();
      dispatch(setCenter({ lat: center.lat, lng: center.lng }));
    },
  });

  return null;
});

export const MapCenterUpdater = React.memo(() => {
  const map = useMap();
  const mapCenter = useSelector((state) => state.map.center);

  useEffect(() => {
    if (mapCenter) {
      map.setView([mapCenter.lat, mapCenter.lng], map.getZoom());
    }
  }, [mapCenter, map]);

  return null;
});

export const createOrderMarker = (element, status, isHovered = false) => {
  const markerSize = 38;
  const markerAnchors = [17, 47];

  // Import OrderMarker dynamically to avoid hook errors
  const OrderMarker = require("../components/map/markers/OrderMarker").default;

  const iconHtml = ReactDOMServer.renderToString(
    <OrderMarker
      idx={element.order_index}
      status={status}
      isSelectedToDispatch={element.selectedToDispatch}
      isHovered={isHovered}
      markerSize={markerSize}
    />
  );

  return L.divIcon({
    className: "custom-icon",
    html: iconHtml,
    iconSize: [markerSize, markerSize],
    iconAnchor: markerAnchors,
  });
};
